<script>
	import { formatAmount, formatCurrency, formatDate, formatPercent } from '../formatting.js';

	export let stock;
	export let show;
	export let href = null;
	export let target = null;

	let value;
	let formatted;

	let style = '';
	let styleClass = '';
	export { style as class }

	$: if (stock != null) {
		value = stock[show];
		if (typeof value === 'number' && show.indexOf('percent') === -1) {
			value = value / stock.factor;
			formatted = formatAmount(value);
		} else if (value != null && value instanceof Date) {
			formatted = formatDate(value);
		} else {
			formatted = value != null ? value : '';
		}
		styleClass = style != null ? style : '';
		styleClass += typeof value !== 'string' && !(value instanceof Date) ? ' text-right' : '';

		// Format percentages accordingly.
		if (show.indexOf('percent') > -1) {
			formatted = formatPercent(value);
			if (show.indexOf('delta') === -1 && formatted.indexOf('+') === 0) {
				formatted = formatted.substr(1); // Remove plus sign for non-delta columns.
			}
		}

		// Set the style to red/green if it's a delta value.
		if (show.indexOf('delta') > -1) {
			styleClass += ' text-' + (value < 0 ? 'danger' : 'success');
			formatted = (value > 0 && show.indexOf('percent') === -1 ? '+' : '') + formatted;
		}
	}
</script>

{#if stock != null && href != null && target != null}
<td class="{styleClass}"><a href={href} class="text-light" data-toggle="modal" data-target={target} data-isin={stock.isin}>{formatted}</a></td>
{:else if stock != null}
<td class="{styleClass}">{formatted}</td>
{:else}
<td>-</td>
{/if}
